// extracted by mini-css-extract-plugin
export default {"container":"container--kev1R","text":"text--hRw2T","button":"button--W03Nk"};